import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { useFlags } from 'launchdarkly-react-client-sdk';
import OrderCard from "./OrderCard";
import { capitalizeObjEntries } from "../../util";
import { Loading } from "../state";

var AccountOrderTabs = function AccountOrderTabs(_ref) {
  var orders = _ref.orders,
      rewards = _ref.rewards,
      isLoading = _ref.isLoading,
      setCurrentOrder = _ref.setCurrentOrder,
      setShowOrderDetails = _ref.setShowOrderDetails,
      setShowMissCreditInfo = _ref.setShowMissCreditInfo;

  var _useState = useState("orderHistory"),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var flags = useFlags();
  var useAccountRewardsTabFlag = flags['releaseRewardsActivityTabInAccountOrders'] ? flags['releaseRewardsActivityTabInAccountOrders'] : false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    defaultActiveKey: "orderHistory",
    onSelect: function onSelect(selectedKey) {
      return setActive(selectedKey);
    },
    className: "account-order-tabs-div"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    className: "account-order-tabs",
    eventKey: "orderHistory"
  }, "Order History")), useAccountRewardsTabFlag ? /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    className: "account-order-tabs",
    eventKey: "rewardsActivity"
  }, "Rewards Activity")) : ""), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card-list"
  }, active === "orderHistory" && !isLoading && orders.length ? orders.map(function (item) {
    var Item = capitalizeObjEntries(item);
    return /*#__PURE__*/React.createElement(OrderCard, {
      key: item.Id,
      item: Item,
      viewDetailsActionCopy: "View Details",
      viewDetailsAction: function viewDetailsAction(e) {
        setCurrentOrder(Item);
        setShowOrderDetails(true);
      }
    });
  }) : active === "rewardsActivity" && !isLoading && rewards.length ? /*#__PURE__*/React.createElement("p", null, "This Shouldn't render") : /*#__PURE__*/React.createElement("div", null, !isLoading && active === "orderHistory" && /*#__PURE__*/React.createElement("p", null, "You don't have any past orders."), !isLoading && active === "rewardsActivity" && /*#__PURE__*/React.createElement("p", null, "You don't have any rewards activity."), isLoading && /*#__PURE__*/React.createElement(Loading, {
    isLoading: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__link"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowMissCreditInfo(true);
    }
  }, "Are you Missing Peg Credit?")));
};

export default AccountOrderTabs;